import "./App.css";
import React, { useState, useEffect , Suspense} from "react";
import NavBar from "./components/NavBar";
import RecipeDetail from "./components/RecipeDetail";
import Login from "./components/Login";
import Pages from "./pages/Pages";
import { BrowserRouter } from "react-router-dom";
import { RecipeContext } from "./context/RecipeContext";
import { db } from "./configs/firebaseconfig";
import { doc, updateDoc, arrayUnion, arrayRemove , onSnapshot} from "firebase/firestore";
import Header from "./components/Header";
import Form from "./components/Form";
import Alert from "./components/Alert";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import Loding from "./components/Loding";
function App() {
  const [dark, setDark] = useState(
    JSON.parse(localStorage.getItem("recipeTheme")) || false
  );
  const [openForm, setOpenForm] = useState({open :false, item:null});
  const [showNav, setShowNav] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [recipeId, setRecipeId] = useState("");
  const [recipType, setRecipType] = useState(null)
  const [savedList, setSavedList] = useState([]);
  const [alert, setAlert] = useState([]);
  const [user, setUser] = useState( null);
  
  const auth = getAuth();
  useEffect(() => {
    const unregisterAuthObserver = onAuthStateChanged(auth, (user) => {
      if (user) {
          setUser(user);
          const unsub = onSnapshot(doc(db, "users", user.uid), (doc) => {
            try {
              setSavedList(doc.data().saved);
            }catch {
             
            }
          });
          return () => {
            unsub();
          
          };
      }
    });
   
    return () => {
      unregisterAuthObserver();
    
    };
  }, [auth]);

 
  function showRecpie(id, type=null) {
    setRecipeId(id);
    setRecipType(type)
  }
  

  async function saveRecipe(saved, id) {
    if (user) {
      const userDocRef = doc(db, "users", user.uid);
    
      if (savedList.includes(id)) {
        await updateDoc(userDocRef, {
          saved: arrayRemove(id),
        });
      } else {
        await updateDoc(userDocRef, {
          saved: arrayUnion(id),
        });
      }
    } else {
      alert("hhhh");
    }
  }

  function closeRecipeDetail() {
    setRecipeId("");
  }
  
 
  
  return (
    <div className={`App ${dark && "dark"}`}>
      <BrowserRouter>
        <NavBar
          showNav={showNav}
          user={user}
          setShowNav={setShowNav}
          setShowLogin={setShowLogin}
          setUser={setUser}
          dark={dark}
          setDark={setDark}
          setOpenForm={setOpenForm}
          showRecpie={showRecpie}
        />
        <div className={`pages-container scrollY ${showNav ? "show-nav":""}`} >
        <RecipeContext.Provider
            value={{
              showRecpie,
              openForm, setOpenForm,
              user,
              savedList,
              setShowNav,
              showNav,
              setShowLogin,
              saveRecipe,
              setAlert
            }}
          >
            <Header/>
            <Suspense fallback={<Loding/>}>
            <Pages />
            </Suspense>
           
          </RecipeContext.Provider>
          {user &&<>
            <Form
        open={openForm}
        setOpen={setOpenForm}
        setAlert={setAlert}
        user={user}
      />
            <Alert alert={alert} setAlert={setAlert} /></> }
          <RecipeDetail id={recipeId} close={closeRecipeDetail} type={recipType}/>
         
        </div>
      </BrowserRouter>
      <Login showLogin={showLogin} setShowLogin={setShowLogin}  setUser={setUser} />
    </div>
  );
}

export default App;
